import { AceClaimItem } from "../../types/claim-item";
import { InferValueTypes } from "../service-types";
import * as actions from "./actions";

export enum Ace2ClaimAction {
  CREATE_CLAIM = "ACE2_CREATE_CLAIM",
  FETCH_CLAIM_INFO = "ACE2_FETCH_CLAIM_INFO",
  DELETE_CLAIM_CREATE_NEW = "ACE2_DELETE_CLAIM_CREATE_NEW",
  INSERT_CLAIM_ITEMS = "ACE2_INSERT_CLAIM_ITEMS",
  REMOVE_CLAIM_ITEM = "ACE2_REMOVE_CLAIM_ITEM",
  INSERT_CLAIM_ITEM_DAMGES = "ACE2_INSERT_CLAIM_ITEM_DAMGES",
  SUBMIT_CLAIM = "ACE2_SUBMIT_CLAIM",
  SET_CLAIM_ID_PLAN = "ACE2_SET_CLAIM_ID_PLAN",
  SET_CLAIM_INFO = "ACE2_SET_CLAIM_INFO",
  CLAIM_ITEM_UPLOAD = "ACE2_CLAIM_ITEM_UPLOAD",
  CLAIM_ITEM_DELETE_IMAGE = "ACE2_CLAIM_ITEM_DELETE_IMAGE",
  GET_CUSTOMER_INFO = "ACE2_GET_CUSTOMER_INFO",
  UPDATE_CUSTOMER_INFO = "ACE2_UPDATE_CUSTOMER_INFO",
  FETCH_WARRNTY_ITEMS = "ACE2_FETCH_WARRNTY_ITEMS",
  DELETE_DAMAGE_ITEM = "ACE2_DELETE_DAMAGE_ITEM",
  SET_WARRNTY_ITEMS = "ACE2_SET_WARRNTY_ITEMS",
  CLEAN_UP = "ACE2_CLEAN_UP_CLAIM_INFO",
  SET_DRAFT_MODAL = "ACE2_SET_DRAFT_MODAL",
  SET_IN_PROCESS_MODAL = "ACE2_SET_IN_PROCESS_MODAL",
}

export interface Ace2ClaimState {
  claimId: string;
  statusCode: string;
  status: string;
  plan: {};
  data: {};
  customerId: string;
  customer_data: {};
  warranty_items: [];
  claim_items: AceClaimItem[];
  draftModal: {
    isShow: boolean;
    claimId: string | null;
  };
  inProcessModal: {
    isShow: boolean;
    claimStatusCode: string | null;
  };
}

export type Ace2ClaimActionTypes = ReturnType<InferValueTypes<typeof actions>>;

export const Ace2ClaimScope = "ace2-claim";
